/**-----------------------------------------------------------------------------
 *                                    E2RH
 * -----------------------------------------------------------------------------
 *
 *  filename: dashboard.js
 *
 *  author: Thomas CLERET (thomas.cleret@proton.me)
 *
 *  creation: 26/9/2025 - 14:25
 *
 *  description:
 *
 *  Copyright (c) 2025 E2RH
 * -----------------------------------------------------------------------------
 */

import * as React from 'react'

/**
 * TODO: Main page component, displays the main content after login
 */
export default function DashBoard() {
   return (
      <div className="dashboard">
         <h1>Dashboard</h1>
      </div>
   );
}
